import { FC, ReactNode, useEffect, useState } from 'react';
import { useAppDispatch } from '../../redux/store';
import axiosInterceptor from './axiosClient';

const AxiosInterceptor: FC<{ children: ReactNode }> = ({ children }) => {
  const [isSet, setIsSet] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const interceptor = axiosInterceptor.interceptors.response.use(response => response);

    setIsSet(true);

    return () => axiosInterceptor.interceptors.response.eject(interceptor);
  }, [dispatch]);

  return isSet ? children : null;
};

export default AxiosInterceptor;
